import { CheckboxMultipleBlankCircleIcon } from './CheckboxMultipleBlankCircleIcon';

/**
 * author: Simran
 * id 0AE5C836-2A43-4706-81C5-5053A73B9CAA
 * name checkbox-multiple-blank-circle
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-blank-circle.svg
 * tags
 * - Form 
 */
export const CheckboxesBlankCircleIcon = CheckboxMultipleBlankCircleIcon;
export default CheckboxesBlankCircleIcon